@layer design-system {
  .typePositive {
    color: var(--viz-bullish);

    circle {
      color: var(--viz-bullish);
    }
  }

  .typeNegative {
    color: var(--viz-bearish);

    circle {
      color: var(--viz-bearish);
    }
  }

  .typeMedian {
    color: var(--border-default);

    path {
      stroke-dasharray: 2;
    }
  }

  .dashed {
    path {
      stroke-dasharray: 2;
    }
  }
}
